<!-- <div *ngIf="isDevMode()" class="w-full text-center">
  <p class="h-12 mt-6 h4-text text-special-red">THIS IS A TEST WEBSITE. NOT FOR PUBLIC USE</p>
</div> -->
<div class="flex flex-col h-full"> 
  <nav class="px-6 md:px-12 lg:px-27" role="banner" *ngIf="user$ | async as userObject"
  [ngClass]="{'bg-transparent z-10 text-white': isHomePage, 'bg-background-secondary text-text-secondary': !isHomePage}">
    <div class="flex flex-wrap items-center justify-between h-20">
      <a routerLink="home">
        <img class="h-12" alt="HorseHopLogo" src="{{isHomePage ?
        'assets/logo_white_txt.svg' :
        'assets/logo_blue_txt.svg'}}" />
      </a>
      <div class="spacer"></div>
      <div class="mx-5" *ngIf="isDevMode()">
        {{userObject.user?.firstName}}
      </div>
      <button class="mr-4" [matMenuTriggerFor]="localeMenu" type="button">
        <div class="flex items-center font-medium">
          <mat-icon fontSet="material-symbols-outlined">language</mat-icon>
          <span class="hidden sm:block roboto-font ml-2">{{currentLocaleLabel}}</span>
        </div>
      </button>
      <div *ngIf="!userObject.isLoading" class="hidden sm:flex items-center gap-2">
        <ng-container *ngIf="!userObject.loggedIn">
          <a routerLink="register" mat-button type="button" class="hidden sm:block"
            [ngClass]="{'navbarWhiteButton': isHomePage, 'navbarGrayButton': !isHomePage}"
            i18n="@@sign-up-menu-item">Sign up</a>
          <a routerLink="login" mat-button type="button" class="hidden sm:block"
            [ngClass]="{'navbarWhiteButton': isHomePage, 'navbarGrayButton': !isHomePage}"
            i18n="@@log-in-menu-item">Log in</a>
        </ng-container>
        <ng-container *ngIf="userObject.loggedIn">
          <a routerLink="/ride-request/search" class="hidden sm:block" mat-button type="button"
            [ngClass]="{'navbarWhiteButton': isHomePage, 'navbarGrayButton': !isHomePage}"
            i18n>Search requests</a>
          <a routerLink="/ride/search" class="hidden sm:block" mat-button type="button"
            [ngClass]="{'navbarWhiteButton': isHomePage, 'navbarGrayButton': !isHomePage}"
            i18n>Search rides</a>
          <a routerLink="messaging" class="hidden sm:block" mat-button type="button"  (click)="onMessageClicked()">
              <img src="{{isHomePage ?
                hasNewMessages ? 'assets/icons/white/message_notification.svg' : 'assets/icons/white/message.svg' :
                hasNewMessages ? 'assets/icons/grey/message_notification.svg' : 'assets/icons/grey/message.svg'}}"/>
          </a>
          <button mat-icon-button [matMenuTriggerFor]="menu" class="hidden sm:block" type="button">
            <mat-icon fontSet="material-symbols-outlined">account_circle</mat-icon>
          </button>
        </ng-container>
        <a class="base-button-small bg-buttons-secondary text-white hidden sm:flex sm:items-center"
        [ngClass]="{'bg-buttons-primary': isHomePage, 'bg-buttons-secondary': !isHomePage}"
            routerLink="/new-ride" i18n>New ride</a>
      </div>
      <button mat-icon-button [matMenuTriggerFor]="menu" class="block sm:hidden-force" type="button">
        <img class="h-6" alt="menu icon" src="{{isHomePage ?
          'assets/icons/white/menu.svg' :
          'assets/icons/dark/menu.svg'}}" />
      </button>
      <mat-menu #menu="matMenu">
        <a mat-menu-item
          *ngIf="userObject.loggedIn"
          routerLink="new-ride"
          class="flex">
          <mat-icon>add_circle_outline</mat-icon>
          <span i18n>New ride</span>
        </a>
        <a mat-menu-item
          *ngIf="userObject.loggedIn"
          routerLink="my-rides"
          class="flex">
          <mat-icon>local_shipping</mat-icon>
          <span i18n>My rides</span>
        </a>
        <a mat-menu-item
          *ngIf="!userObject.loggedIn"
          routerLink="register">
          <!-- TO DO: Add icon -->
          <span i18n="@@sign-up-menu-item">Sign up</span>
        </a>
        <a mat-menu-item
          *ngIf="!userObject.loggedIn"
          routerLink="login">
          <!-- TO DO: Add icon -->
          <span i18n="@@log-in-menu-item">Log in</span>
        </a>
        <button *ngIf="userObject.loggedIn" mat-menu-item routerLink="ride/search" type="button" class="flex">
          <mat-icon>
            travel_explore
          </mat-icon>
          <span i18n>Search rides</span>
        </button>
        <button *ngIf="userObject.loggedIn" mat-menu-item routerLink="ride-request/search" type="button" class="flex">
          <mat-icon>
            content_paste_search
          </mat-icon>
          <span i18n>Search requests</span>
        </button>
        <button *ngIf="userObject.loggedIn" mat-menu-item routerLink="messaging" type="button" class="flex"
          (click)="onMessageClicked()">
          <mat-icon>
            chat
          </mat-icon>
          <span i18n>Messages</span>
        </button>
        <a mat-menu-item
          *ngIf="userObject.loggedIn"
          routerLink="profile"
          class="flex">
          <mat-icon>account_circle</mat-icon>
          <span i18n>Profile</span>
        </a>
        <button *ngIf="userObject.loggedIn" mat-menu-item (click)="logout()" color="white" type="button">
          <mat-icon>logout</mat-icon>
          <span i18n>Log out</span>
        </button>
      </mat-menu>
      <mat-menu #localeMenu="matMenu">
        <button mat-menu-item *ngFor="let locale of localesList" (click)="changeLocale(locale.locale)" type="button">
          {{locale.label}}
        </button>
      </mat-menu>
    </div>
  </nav>

  <div class="flex-1 bg-background-secondary" role="main">
    <router-outlet></router-outlet>
  </div>

  <footer class="md:h-52 w-full flex flex-col justify-around
   bg-background-grey text-text-secondary text-center
   py-6 px-5 md:px-12 lg:px-27">
    <div class="md:h-1/2 flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-4 lg:gap-8 pb-6">
      <img class="h-12" alt="HorseHopLogo" src="assets/logo_mono_gray.svg" />
      <div class="footerLinkGrid w-full flex-grow grid grid-cols-2 md:grid-cols-5 body-s-text
      gap-6 md:gap-0 max-md:text-left">
        <a routerLink="/ride/search" i18n>Search rides</a>
        <a routerLink="/feedback" i18n>Contact us</a>
        <a routerLink="/faq" i18n>FAQ</a>
        <a href="/blog" i18n>Blog</a>
        <a routerLink="/about" i18n>About us</a>
      </div>
      <div class="flex flex-col md:flex-row w-full md:w-98 gap-8 md:gap-4">
        <mat-form-field subscriptSizing="dynamic" class="w-full">
          <input matInput [(ngModel)]="subscriberEmail" type="email"
            i18n-placeholder placeholder="Subscribe for news" />
        </mat-form-field>
        <button *ngIf="!subscribed"
                class="secondary-button"
                (click)="subscribe()"
                type="button"
                i18n>Subscribe</button>
        <button *ngIf="subscribed"
                class="primary-button"
                type="button" i18n>Subscribed!</button>
      </div>
    </div>
    <div class="bottomFooterSection md:h-1/2 flex max-md:flex-col-reverse gap-6 justify-between pt-6">
      <div class="flex flex-col justify-end items-start gap-2 md:gap-4">
        <div class="flex flex-wrap md:h-6 gap-4 md:gap-8 body-s-text">
          <a routerLink="/legal/privacy-policy" i18n>Privacy Policy</a>
          <a routerLink="/legal/terms-of-service" i18n>Terms of Service</a>
          <a routerLink="/legal/cookie-policy" i18n>Cookie Policy</a>
          <a routerLink="/cookie-consent" i18n>Cookie Management</a>
        </div>
        <span class="opacity-50 h-6" i18n>© 2025 Horse Hop. All rights reserved.</span>
      </div>
      <!-- <div class="flex justify-between">
        <a href="https://instagram.com/horsehop.eu" target="_blank">
          <img class="h-6" alt="Instagram" src="assets/brand-instagram.svg" />
        </a>
        <a href="https://facebook.com/horse-hop" class="ml-4">
          <img class="h-6" alt="Facebook" src="assets/brand-facebook.svg" />
        </a>
        <a href="https://tiktok.com/horse-hop" class="ml-4">
          <img class="h-6" alt="Twitter" src="assets/brand-tiktok.svg" />
        </a>
      </div> -->
    </div>
  </footer>
</div>
